import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import { useNotifications } from 'src/notifications';
import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import { API_INBOXES_PATH } from 'src/services/api/inboxes/constants';
import {type IInbox} from 'src/services/api/inboxes/types';

type ICreateInboxRequest = Omit<IInbox, 'id' | 'landlord_user_id' | 'leasing_team_id' | 'is_primary'>;
type ICreateViewResponse = {
    inbox: IInbox
}

export const useCreateInbox = () => {
    const queryClient = useQueryClient();
    const { addNotification } = useNotifications();

    return useMutation<ICreateViewResponse, IStandardErrorResponse, ICreateInboxRequest>(
        async (payload) => {
            return apiClient(API_INBOXES_PATH, {
                method: 'post',
                json: payload,
            }).json<ICreateViewResponse>();
        }, {
            onSuccess: (res) => {
                addNotification('Inbox created', 'success');

                queryClient.setQueryData<IInbox[]>(queryKeys.inboxes, (oldData) => {
                    if (!oldData) {
                        return [res.inbox];
                    }

                    return [...oldData, res.inbox];
                });
            }, onError: (error) => {
                const schemaValidationError = error?.messages?.map(message => message.msg).join(', ');
                console.error('Failed to create inbox', error);
                const errorMessage = schemaValidationError || error.msg || 'Failed to create inbox';
                addNotification(errorMessage, 'error');
            }
        }
    );
};
